var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{attrs:{"title":"No internet connection","zIndex":120,"closeButton":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"container text-container py-5"},[_c('p',[_vm._v(" Please check your internet connection. ")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }